"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceNumbering = class InvoiceNumbering extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    company;
    onCompany(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("company");
    }
    saving;
    onSaving(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("saving");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.oid
            ? this.$fn.fetch('read_numbering', { parameters: { id: this.oid }, asResource: true })
            : this.$fn.schemaDefaults('CreateNumbering', _.extend({
                start: 1,
                increment: 1,
                variables: []
            }, this.createParams));
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3083451129821185_paging;
    b_3083451129821185_columns;
    dataMembers = ['item', 'formId', 'ux', 'b_7315092382398562_modalBindings', 'b_3083451129821185_paging', 'b_3083451129821185_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                formId: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_3083451129821185_paging: false,
                b_3083451129821185_columns: [{
                        name: "id",
                        header: this.$fn.pgettext("Numbering", "ID"),
                        width: "120px",
                        required: true,
                    },
                    {
                        name: "name",
                        header: this.$fn.pgettext("Numbering", "Name"),
                        width: "120px",
                        required: true,
                    },
                    {
                        name: "data_type",
                        header: this.$fn.pgettext("Numbering", "Data type"),
                        width: "120px",
                        required: true,
                    },
                    {
                        name: "value",
                        header: this.$fn.pgettext("Numbering", "Value"),
                        width: "120px",
                        required: true,
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [!this.oid && this.$fn.gettext('New Numbering'),
                    this.oid && this.company.name,
                ],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3764_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_script_3768_getActionArgs_value($event) {
        this.saving(this.item.getData()).then(result => this.$imodal.close(this.componentName, { ok: true, value: result }));
    }
    async act_1040167445267876_script_3768_getActionArgs($event) {
        return {
            value: () => this.act_1040167445267876_script_3768_getActionArgs_value($event),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_3770_getActionArgs($event) {
        return {
            name: this.modalName,
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3764 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3764_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3763 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3764,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3763],
        });
        const act_2248226175642056_closeComponent_3766 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3765 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3766,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3765],
        });
        const act_1040167445267876_script_3768 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1040167445267876_script_3768_getActionArgs,
            displayName: "submit",
            events: [],
        });
        const evh_1040167445267876_submit_3767 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_script_3768,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3767],
        });
        const act_1419464017721962_closeModal_3770 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_3770_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3769 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_3770,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3769],
        });
        return {
            act_7315092382398562_closeModal_3764,
            evh_7315092382398562_close_3763,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3766,
            evh_2248226175642056_close_3765,
            evh_2248226175642056_close,
            act_1040167445267876_script_3768,
            evh_1040167445267876_submit_3767,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_3770,
            evh_1419464017721962_clickPreventStop_3769,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_script_3768,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], InvoiceNumbering.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceNumbering.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], InvoiceNumbering.prototype, "company", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('company'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceNumbering.prototype, "onCompany", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], InvoiceNumbering.prototype, "saving", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('saving'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceNumbering.prototype, "onSaving", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], InvoiceNumbering.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceNumbering.prototype, "onSize", null);
InvoiceNumbering = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceNumbering);
exports.default = InvoiceNumbering;
vue_property_decorator_1.Vue.component("InvoiceNumbering", InvoiceNumbering);
